module.exports = __webpack_public_path__ + "img/vpn-1.2c6d37ad.webp";